import { render, staticRenderFns } from "./infordetails.html?vue&type=template&id=4069cd96&scoped=true&"
import script from "./infordetails.js?vue&type=script&lang=js&"
export * from "./infordetails.js?vue&type=script&lang=js&"
import style0 from "./infordetails.sass?vue&type=style&index=0&id=4069cd96&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4069cd96",
  null
  
)

component.options.__file = "infordetails.vue"
export default component.exports